import { Button, Image } from 'antd-mobile';
import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { IoLogoApple } from 'react-icons/io5';
import { IoLogoAndroid } from 'react-icons/io';
import { isAndroid, isMobileSafari } from 'react-device-detect';
import { getAppLogo, getAppName } from 'utils/common';
import { LocalStorage, STORAGE_KEY } from 'utils/localStorage';

const Storage = new LocalStorage();

function InstallOverlay() {
  const { t } = useTranslation();
  const installPrompt = useRef<any>();
  const [isShowGuide, setIsShowGuide] = useState(false);
  const [canInstall, setCanInstall] = useState(false);

  const handleUserAction = () => {
    if (installPrompt.current) {
      installPrompt.current.prompt();
      installPrompt.current = null;
      setCanInstall(false);
    } else {
      alert('Bạn vui lòng kiểm tra xem đã cài ứng dụng này trước đó chưa nhé!');
    }
  };

  const handleShowGuide = () => {
    setIsShowGuide(true);
  };

  //NOTE: Ghi nhớ là app đã cài rồi để isPWA() lần sau trả true ngay, không phải chờ
  //Chrome đọc xong manifest mới quyết định được render gì.
  const handleOpenApp = () => {
    Storage.setStorageItem(STORAGE_KEY.IS_PWA_INSTALLED, true);
    window.location.reload();
  };

  useEffect(() => {
    const handler = (event: any) => {
      event.preventDefault();
      alert('📣 Chào mừng bạn đến với ứng dụng quản lý căn hộ dịch vụ thông minh 📣');
      installPrompt.current = event;
      setCanInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  return isShowGuide ? (
    <div className={styles.guide}>
      <p
        className="font-xl color-white font-bold"
        style={{
          textAlign: 'center',
        }}
      >
        {t('paragraph.install-guide')}
      </p>
      <p className="font-lg color-white font-medium">{`${t('title.step')} 1:`}</p>
      <Image src="/images/guide/step-01.jpg" />
      <p className="font-lg color-white font-medium">{`${t('title.step')} 2:`}</p>
      <Image src="/images/guide/step-02.jpg" />
      <p className="font-lg color-white font-medium">{`${t('title.step')} 3:`}</p>
      <Image src="/images/guide/step-03.jpg" />
    </div>
  ) : (
    <div className={styles.container}>
      <div className={styles.logo}>
        <div
          style={{
            width: '100px',
            height: '100px',
            background: 'var(--white-01)',
            borderRadius: '100px',
            overflow: 'hidden',
            marginBottom: '24px',
            border: '2px solid var(--white-01)',
          }}
        >
          <Image
            src={getAppLogo()}
            alt="logo"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </div>
        <p className={`font-xxxl color-white font-bold ${styles.animation}`}>{getAppName()}</p>
        {isMobileSafari ? (
          <Button
            color="warning"
            style={{
              fontSize: 'var(--font-lg)',
            }}
            onClick={handleShowGuide}
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '6px',
              }}
            >
              <IoLogoApple
                fontSize="26px"
                style={{
                  position: 'relative',
                  bottom: '2px',
                }}
              />
              {t('button.tutorial')}
            </span>
          </Button>
        ) : isAndroid ? (
          canInstall ? (
            <Button
              color="warning"
              style={{
                fontSize: 'var(--font-lg)',
              }}
              onClick={handleUserAction}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '6px',
                }}
              >
                <IoLogoAndroid
                  fontSize="26px"
                  style={{
                    position: 'relative',
                    bottom: '0px',
                  }}
                />
                {t('button.install')}
              </span>
            </Button>
          ) : (
            <Button
              color="warning"
              style={{
                fontSize: 'var(--font-lg)',
              }}
              onClick={handleOpenApp}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '6px',
                }}
              >
                <IoLogoAndroid
                  fontSize="26px"
                  style={{
                    position: 'relative',
                    bottom: '0px',
                  }}
                />
                {t('button.open-app')}
              </span>
            </Button>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default React.memo(InstallOverlay);
